import { render, staticRenderFns } from "./OrderProductsList.vue?vue&type=template&id=440b68f2&scoped=true"
import script from "./OrderProductsList.vue?vue&type=script&lang=js"
export * from "./OrderProductsList.vue?vue&type=script&lang=js"
import style0 from "./OrderProductsList.vue?vue&type=style&index=0&id=440b68f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b68f2",
  null
  
)

export default component.exports